export default __webpack_public_path__ + "dist/media/Signed.22b3bd36.svg";